export const detectionKindsMap = {
  pothole: { val: 'ポットホール', dispOrder: 1 },
  crack: { val: 'ヒビ', dispOrder: 2 },
  joint_damage: { val: 'ジョイント損傷', dispOrder: 3 },
};

export const detectionKinds = Object.entries(detectionKindsMap).map(e => {
  return { key: e[0], val: e[1].val };
});
